import createDataContext from "./createData.context";

import authReducer from "../reducers/auth.reducer";
import {
  login,
  logout,
} from "../actions/auth.actions";


const initialState = {
  user: null || JSON.parse(localStorage.getItem("user")),
  loading: false,
  error: null,
};

export const { Context: AuthContext, Provider: AuthProvider } =
  createDataContext(
    authReducer,
    {
      login,
      logout,
    },
    initialState
  );
